

export function addOrIncrementToViewHistory(vehicleId) {
    const viewHistory = JSON.parse(localStorage.getItem('usedVehicleViewHistory'));
    let data = {};

    if(!viewHistory) {
        data = {
            [vehicleId]: {
                views: 1
            }
        };

    } else if(viewHistory && !viewHistory.hasOwnProperty(vehicleId)) {
        data = {...viewHistory,
            [vehicleId]: {
                views: 1
            }
        };

    } else {
        data = {...viewHistory,
            [vehicleId]: {
                views: viewHistory[vehicleId].views + 1
            }
        };

    }

    localStorage.setItem('usedVehicleViewHistory', JSON.stringify(data));

};

export default {
    addOrIncrementToViewHistory
};







// WEBPACK FOOTER //
// ./resources/assets/js/usedVehicleViewHistoryLocalStorage.js